import { useEffect, useState } from "react";
import moment from "moment";
import { getSocket } from "@/services/socketService";
import { useLayout } from "@/contexts/UseLayout";
import { useQuery } from "@tanstack/react-query";
import servicePainel from "@/services/ServicePainel";

const socket = getSocket();

export function PainelPage() {
  const [deskPainel, setDeskPainel] = useState<any>([]);

  const { data: desks, isLoading } = useQuery({
    queryKey: ["getDesksPainel"],
    queryFn: async () => await servicePainel?.getDesksPainel(),
  });

  const { userLogged } = useLayout();
  const [jobsEmBriefing, setJobsEmBriefing] = useState(
    deskPainel?.filter((item: any) => [21, 22, 37, 38].includes(item.status_id))
  );

  const [jobsAtivos, setJobAtivos] = useState(
    deskPainel?.filter((item: any) =>
      [23, 24, 25, 39, 40, 41].includes(item.status_id)
    )
  );

  const [jobsAprovacao, setJobAprovacao] = useState(
    deskPainel?.filter((item: any) => [26, 27, 42, 43].includes(item.status_id))
  );

  const [jobsFinalizacao, setJobFinalizacao] = useState(
    deskPainel?.filter((item: any) =>
      [28, 29, 44, 45, 46].includes(item.status_id)
    )
  );

  useEffect(() => {
    if (desks) {
      setDeskPainel(desks.data);
    }
  }, [desks]);

  useEffect(() => {
    setJobsEmBriefing(
      deskPainel?.filter((item: any) =>
        [21, 22, 37, 38].includes(item.status_id)
      )
    );
    setJobAtivos(
      deskPainel?.filter((item: any) =>
        [23, 24, 25, 39, 40, 41].includes(item.status_id)
      )
    );
    setJobAprovacao(
      deskPainel?.filter((item: any) =>
        [26, 27, 42, 43].includes(item.status_id)
      )
    );
    setJobFinalizacao(
      deskPainel?.filter((item: any) =>
        [28, 29, 44, 45, 46].includes(item.status_id)
      )
    );
  }, [deskPainel]);

  useEffect(() => {
    const deskHandler = (data: any) => {
      setDeskPainel(data);
    };

    socket.on(
      `notification:desksPainelSteakHolder:${userLogged.data.empresa_id}`,
      deskHandler
    );

    return () => {
      // Apenas remove o listener, não desconecta o socket compartilhado
      socket.off(
        `notification:desksPainelSteakHolder:${userLogged.data.empresa_id}`,
        deskHandler
      );
    };
  }, [userLogged.data?.empresa_id]);

  return (
    <div className="grid md:grid-cols-2 gap-10 p-10 items-stretch min-h-screen">
      {isLoading ? (
        [...Array(4)].map((_, index) => (
          <div
            key={index}
            className="bg-gray-200 rounded-lg flex gap-2 relative items-center p-4 cursor-pointer animate-pulse w-full"
          >
            <span className="block h-10 w-10 bg-gray-300 rounded-full"></span>
            <div className="flex-1">
              <div className="h-6 bg-gray-300 rounded mb-2 text-red-500"></div>
              <div className="h-4 bg-gray-300 rounded"></div>
            </div>
            <p className="absolute -bottom-3 right-3 py-1 px-4 text-xs rounded-lg bg-gray-300"></p>
          </div>
        ))
      ) : (
        <>
          {/* Em briefing */}
          <div className="bg-white text-cinza-800 rounded-lg p-4 relative">
            <h3 className="text-lg font-bold mb-4 absolute -top-5 bg-azul-400 text-white rounded-lg px-10">
              Em briefing
            </h3>
            <div className="h-56 overflow-y-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-cinza-300 font-medium">
                    <td>Cliente</td>
                    <td>Nome do Projeto</td>
                    <td className="text-center">Nº Projeto</td>
                    <td className="text-center">Entrega</td>
                    <td className="text-center">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {jobsEmBriefing?.map((e: any) => (
                    <tr key={e.id} className="text-sm">
                      <td className="truncate max-w-20">
                        {e?.cliente?.name_fantasy ?? "-"}
                      </td>
                      <td className="truncate max-w-24">{e?.name}</td>
                      <td className="text-center">{e?.id}</td>
                      <td className="text-center">
                        {moment.utc(e?.date_init).format("DD/MM HH:mm")}
                      </td>
                      <td
                        className={`${
                          [21, 23, 26, 28, 37].includes(e.status_id)
                            ? "text-azul-400"
                            : "text-verde-300"
                        } text-center`}
                      >
                        {e?.status?.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white text-cinza-800 rounded-lg p-4 relative">
            <h3 className="text-lg font-bold mb-4 absolute -top-5 bg-azul-400 text-white rounded-lg px-10">
              Ativo
            </h3>
            <div className="h-56 overflow-y-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-sm text-cinza-300 font-medium">
                    <td>Cliente</td>
                    <td>Nome do Projeto</td>
                    <td className="text-center">Nº Projeto</td>
                    <td className="text-center">Entrega</td>
                    <td className="text-center">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {jobsAtivos?.map((e: any) => (
                    <tr key={e.id}>
                      <td className="truncate max-w-20">
                        {e?.cliente?.name_fantasy ?? "-"}
                      </td>
                      <td className="truncate max-w-20">{e?.name}</td>
                      <td className="text-center">{e?.id}</td>
                      <td className="text-center">
                        {moment.utc(e?.date_init).format("DD/MM/YY HH:mm")}
                      </td>
                      <td
                        className={`${
                          [21, 23, 26, 28, 37].includes(e.status_id)
                            ? "text-azul-400"
                            : "text-verde-300"
                        } text-center`}
                      >
                        {e?.status?.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white text-cinza-800 rounded-lg p-4 relative">
            <h3 className="text-lg font-bold mb-4 absolute -top-5 bg-azul-400 text-white rounded-lg px-10">
              Aprovação
            </h3>
            <div className="h-56 overflow-y-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-sm text-cinza-300 font-medium">
                    <td>Cliente</td>
                    <td>Nome do Projeto</td>
                    <td className="text-center">Nº Projeto</td>
                    <td className="text-center">Entrega</td>
                    <td className="text-center">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {jobsAprovacao?.map((e: any) => (
                    <tr key={e.id}>
                      <td className="truncate max-w-20">
                        {e?.cliente?.name_fantasy ?? "-"}
                      </td>
                      <td className="truncate max-w-20">{e?.name}</td>
                      <td className="text-center">{e?.id}</td>
                      <td className="text-center">
                        {moment.utc(e?.date_init).format("DD/MM/YY HH:mm")}
                      </td>
                      <td
                        className={`${
                          [21, 23, 26, 28, 37].includes(e.status_id)
                            ? "text-azul-400"
                            : "text-verde-300"
                        } text-center`}
                      >
                        {e?.status?.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white text-cinza-800 rounded-lg p-4 relative">
            <h3 className="text-lg font-bold mb-4 absolute -top-5 bg-azul-400 text-white rounded-lg px-10">
              Aguardando Cliente
            </h3>
            <div className="h-56 overflow-y-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-sm text-cinza-300 font-medium">
                    <td className="truncate max-w-20">Cliente</td>
                    <td className="truncate max-w-20">Nome do Projeto</td>
                    <td className="text-center">Nº Projeto</td>
                    <td className="text-center">Entrega</td>
                    <td className="text-center">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {jobsFinalizacao?.map((e: any) => (
                    <tr key={e.id}>
                      <td className="truncate max-w-20">
                        {e?.cliente?.name_fantasy ?? "-"}
                      </td>
                      <td className="truncate max-w-24">{e?.name}</td>
                      <td className="text-center">{e?.id}</td>
                      <td className="text-center">
                        {moment.utc(e?.date_init).format("DD/MM/YY HH:mm")}
                      </td>
                      <td
                        className={`${
                          [21, 23, 26, 28, 37].includes(e.status_id)
                            ? "text-azul-400"
                            : "text-verde-300"
                        } text-center`}
                      >
                        {e?.status?.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
